import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class List extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;
        const array = [];
        let list = [];

        content.forEach((item, index) => {
            if (index % 2 === 0) {
                list.push(
                    <h2 key={index} className={styles.title}>
                        {item.children && item.children.length > 0 ? (
                            <React.Fragment>
                                <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                    {item.title}
                                </a>
                                {item.children.map((child, index) => (
                                    <React.Fragment key={index}>
                                        <a href={child.url} target="_blank" title={child.title} rel="noreferrer">
                                            {child.title}
                                        </a>
                                    </React.Fragment>
                                ))}
                            </React.Fragment>
                        ) : (
                            <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                {item.title}
                            </a>
                        )}
                    </h2>,
                );
            } else {
                list.push(
                    <div className={styles.box_01_1} key={index}>
                        <h3 className={styles.text}>
                            {item.children && item.children.length > 0 ? (
                                <React.Fragment>
                                    <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                        {item.title}
                                    </a>
                                    {item.children.slice(0, 1).map((child, index) => (
                                        <React.Fragment key={index}>
                                            <a href={child.url} target="_blank" title={child.title} rel="noreferrer">
                                                {child.title}
                                            </a>
                                        </React.Fragment>
                                    ))}
                                </React.Fragment>
                            ) : (
                                <a href={item.url} target="_blank" title={item.title} rel="noreferrer">
                                    {item.title}
                                </a>
                            )}
                        </h3>
                        {item.children && item.children.length > 1 ? (
                            <h3 key={index} className={styles.text}>
                                {item.children.slice(1, 3).map((child, index) => (
                                    <React.Fragment key={index}>
                                        <a href={child.url} target="_blank" title={child.title} rel="noreferrer">
                                            {child.title}
                                        </a>
                                    </React.Fragment>
                                ))}
                            </h3>
                        ) : (
                            <div />
                        )}
                    </div>,
                );
                array.push(
                    <div key={index} className={styles.hot}>
                        {list}
                    </div>,
                );
                list = [];
            }
        });

        return <div style={{ position: 'relative' }}>{array}</div>;
    }
}

export default errorBoundary(List);
